// extracted by mini-css-extract-plugin
module.exports = {"container":"Remarks_container__1_hEn","title":"Remarks_title__RRE4b"};